import "./main.css";
import {useStyleProps as $4hD9r$useStyleProps, useFocusableRef as $4hD9r$useFocusableRef, classNames as $4hD9r$classNames, useDOMRef as $4hD9r$useDOMRef} from "@react-spectrum/utils";
import {FocusRing as $4hD9r$FocusRing} from "@react-aria/focus";
import $4hD9r$react, {useRef as $4hD9r$useRef, forwardRef as $4hD9r$forwardRef, useContext as $4hD9r$useContext} from "react";
import {useHover as $4hD9r$useHover} from "@react-aria/interactions";
import {useRadio as $4hD9r$useRadio, useRadioGroup as $4hD9r$useRadioGroup} from "@react-aria/radio";
import {Field as $4hD9r$Field} from "@react-spectrum/label";
import {useFormProps as $4hD9r$useFormProps} from "@react-spectrum/form";
import {useProviderProps as $4hD9r$useProviderProps} from "@react-spectrum/provider";
import {useRadioGroupState as $4hD9r$useRadioGroupState} from "@react-stately/radio";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


var $d1246d70e6c52742$exports = {};

$parcel$export($d1246d70e6c52742$exports, "focus-ring", () => $d1246d70e6c52742$export$f39a09f249340e2a, (v) => $d1246d70e6c52742$export$f39a09f249340e2a = v);
$parcel$export($d1246d70e6c52742$exports, "i18nFontFamily", () => $d1246d70e6c52742$export$8c4ee2c50c22c514, (v) => $d1246d70e6c52742$export$8c4ee2c50c22c514 = v);
$parcel$export($d1246d70e6c52742$exports, "is-hovered", () => $d1246d70e6c52742$export$b8813cd5d7824ce7, (v) => $d1246d70e6c52742$export$b8813cd5d7824ce7 = v);
$parcel$export($d1246d70e6c52742$exports, "is-invalid", () => $d1246d70e6c52742$export$14a30de2866685fa, (v) => $d1246d70e6c52742$export$14a30de2866685fa = v);
$parcel$export($d1246d70e6c52742$exports, "spectrum-FocusRing-ring", () => $d1246d70e6c52742$export$4109102f950813a6, (v) => $d1246d70e6c52742$export$4109102f950813a6 = v);
$parcel$export($d1246d70e6c52742$exports, "spectrum-FocusRing", () => $d1246d70e6c52742$export$24c7f46a6e3605dd, (v) => $d1246d70e6c52742$export$24c7f46a6e3605dd = v);
$parcel$export($d1246d70e6c52742$exports, "spectrum-FocusRing--quiet", () => $d1246d70e6c52742$export$2927016961429360, (v) => $d1246d70e6c52742$export$2927016961429360 = v);
$parcel$export($d1246d70e6c52742$exports, "spectrum-Radio", () => $d1246d70e6c52742$export$26ebd4dbfef068c5, (v) => $d1246d70e6c52742$export$26ebd4dbfef068c5 = v);
$parcel$export($d1246d70e6c52742$exports, "spectrum-Radio--labelBelow", () => $d1246d70e6c52742$export$9443e7082698950d, (v) => $d1246d70e6c52742$export$9443e7082698950d = v);
$parcel$export($d1246d70e6c52742$exports, "spectrum-Radio--quiet", () => $d1246d70e6c52742$export$6db66b55a897f36d, (v) => $d1246d70e6c52742$export$6db66b55a897f36d = v);
$parcel$export($d1246d70e6c52742$exports, "spectrum-Radio-button", () => $d1246d70e6c52742$export$bf9d5e902c33bf05, (v) => $d1246d70e6c52742$export$bf9d5e902c33bf05 = v);
$parcel$export($d1246d70e6c52742$exports, "spectrum-Radio-input", () => $d1246d70e6c52742$export$c0ce6f9a6a2de1cc, (v) => $d1246d70e6c52742$export$c0ce6f9a6a2de1cc = v);
$parcel$export($d1246d70e6c52742$exports, "spectrum-Radio-label", () => $d1246d70e6c52742$export$b0f8395a9667922d, (v) => $d1246d70e6c52742$export$b0f8395a9667922d = v);
var $d1246d70e6c52742$export$f39a09f249340e2a;
var $d1246d70e6c52742$export$8c4ee2c50c22c514;
var $d1246d70e6c52742$export$b8813cd5d7824ce7;
var $d1246d70e6c52742$export$14a30de2866685fa;
var $d1246d70e6c52742$export$4109102f950813a6;
var $d1246d70e6c52742$export$24c7f46a6e3605dd;
var $d1246d70e6c52742$export$2927016961429360;
var $d1246d70e6c52742$export$26ebd4dbfef068c5;
var $d1246d70e6c52742$export$9443e7082698950d;
var $d1246d70e6c52742$export$6db66b55a897f36d;
var $d1246d70e6c52742$export$bf9d5e902c33bf05;
var $d1246d70e6c52742$export$c0ce6f9a6a2de1cc;
var $d1246d70e6c52742$export$b0f8395a9667922d;
$d1246d70e6c52742$export$f39a09f249340e2a = `V2HKpq_focus-ring`;
$d1246d70e6c52742$export$8c4ee2c50c22c514 = `V2HKpq_i18nFontFamily`;
$d1246d70e6c52742$export$b8813cd5d7824ce7 = `V2HKpq_is-hovered`;
$d1246d70e6c52742$export$14a30de2866685fa = `V2HKpq_is-invalid`;
$d1246d70e6c52742$export$4109102f950813a6 = `V2HKpq_spectrum-FocusRing-ring`;
$d1246d70e6c52742$export$24c7f46a6e3605dd = `V2HKpq_spectrum-FocusRing ${$d1246d70e6c52742$export$4109102f950813a6}`;
$d1246d70e6c52742$export$2927016961429360 = `V2HKpq_spectrum-FocusRing--quiet`;
$d1246d70e6c52742$export$26ebd4dbfef068c5 = `V2HKpq_spectrum-Radio`;
$d1246d70e6c52742$export$9443e7082698950d = `V2HKpq_spectrum-Radio--labelBelow`;
$d1246d70e6c52742$export$6db66b55a897f36d = `V2HKpq_spectrum-Radio--quiet`;
$d1246d70e6c52742$export$bf9d5e902c33bf05 = `V2HKpq_spectrum-Radio-button`;
$d1246d70e6c52742$export$c0ce6f9a6a2de1cc = `V2HKpq_spectrum-Radio-input`;
$d1246d70e6c52742$export$b0f8395a9667922d = `V2HKpq_spectrum-Radio-label`;




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
const $f394bff9e10389a0$export$b118023277d4a5c3 = (0, $4hD9r$react).createContext(null);
function $f394bff9e10389a0$export$b054eba74077a826() {
    return (0, $4hD9r$useContext)($f394bff9e10389a0$export$b118023277d4a5c3);
}


function $337c5cb580c4e6ba$var$Radio(props, ref) {
    let { isDisabled: isDisabled, children: children, autoFocus: autoFocus, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $4hD9r$useStyleProps)(otherProps);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $4hD9r$useHover)({
        isDisabled: isDisabled
    });
    let inputRef = (0, $4hD9r$useRef)(null);
    let domRef = (0, $4hD9r$useFocusableRef)(ref, inputRef);
    let radioGroupProps = (0, $f394bff9e10389a0$export$b054eba74077a826)();
    let { isEmphasized: isEmphasized, state: state } = radioGroupProps;
    let { inputProps: inputProps } = (0, $4hD9r$useRadio)({
        ...props,
        ...radioGroupProps,
        isDisabled: isDisabled
    }, state, inputRef);
    return /*#__PURE__*/ (0, $4hD9r$react).createElement("label", {
        ...styleProps,
        ...hoverProps,
        ref: domRef,
        className: (0, $4hD9r$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($d1246d70e6c52742$exports))), "spectrum-Radio", {
            // Removing. Pending design feedback.
            // 'spectrum-Radio--labelBelow': labelPosition === 'bottom',
            "spectrum-Radio--quiet": !isEmphasized,
            "is-disabled": isDisabled,
            "is-invalid": state.isInvalid,
            "is-hovered": isHovered
        }, styleProps.className)
    }, /*#__PURE__*/ (0, $4hD9r$react).createElement((0, $4hD9r$FocusRing), {
        focusRingClass: (0, $4hD9r$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($d1246d70e6c52742$exports))), "focus-ring"),
        autoFocus: autoFocus
    }, /*#__PURE__*/ (0, $4hD9r$react).createElement("input", {
        ...inputProps,
        ref: inputRef,
        className: (0, $4hD9r$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($d1246d70e6c52742$exports))), "spectrum-Radio-input")
    })), /*#__PURE__*/ (0, $4hD9r$react).createElement("span", {
        className: (0, $4hD9r$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($d1246d70e6c52742$exports))), "spectrum-Radio-button")
    }), children && /*#__PURE__*/ (0, $4hD9r$react).createElement("span", {
        className: (0, $4hD9r$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($d1246d70e6c52742$exports))), "spectrum-Radio-label")
    }, children));
}
/**
 * Radio buttons allow users to select a single option from a list of mutually exclusive options.
 * All possible options are exposed up front for users to compare.
 */ const $337c5cb580c4e6ba$export$d7b12c4107be0d61 = /*#__PURE__*/ (0, $4hD9r$forwardRef)($337c5cb580c4e6ba$var$Radio);


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 



var $4cb2b26710154c56$exports = {};

$parcel$export($4cb2b26710154c56$exports, "focus-ring", () => $4cb2b26710154c56$export$f39a09f249340e2a, (v) => $4cb2b26710154c56$export$f39a09f249340e2a = v);
$parcel$export($4cb2b26710154c56$exports, "i18nFontFamily", () => $4cb2b26710154c56$export$8c4ee2c50c22c514, (v) => $4cb2b26710154c56$export$8c4ee2c50c22c514 = v);
$parcel$export($4cb2b26710154c56$exports, "spectrum-FieldGroup", () => $4cb2b26710154c56$export$75eb16cbfc18279c, (v) => $4cb2b26710154c56$export$75eb16cbfc18279c = v);
$parcel$export($4cb2b26710154c56$exports, "spectrum-FieldGroup-group", () => $4cb2b26710154c56$export$984c7bbbfc7ddffc, (v) => $4cb2b26710154c56$export$984c7bbbfc7ddffc = v);
$parcel$export($4cb2b26710154c56$exports, "spectrum-FieldGroup-group--horizontal", () => $4cb2b26710154c56$export$1ad8646bcba21c0e, (v) => $4cb2b26710154c56$export$1ad8646bcba21c0e = v);
$parcel$export($4cb2b26710154c56$exports, "spectrum-FocusRing-ring", () => $4cb2b26710154c56$export$4109102f950813a6, (v) => $4cb2b26710154c56$export$4109102f950813a6 = v);
$parcel$export($4cb2b26710154c56$exports, "spectrum-FocusRing", () => $4cb2b26710154c56$export$24c7f46a6e3605dd, (v) => $4cb2b26710154c56$export$24c7f46a6e3605dd = v);
$parcel$export($4cb2b26710154c56$exports, "spectrum-FocusRing--quiet", () => $4cb2b26710154c56$export$2927016961429360, (v) => $4cb2b26710154c56$export$2927016961429360 = v);
var $4cb2b26710154c56$export$f39a09f249340e2a;
var $4cb2b26710154c56$export$8c4ee2c50c22c514;
var $4cb2b26710154c56$export$75eb16cbfc18279c;
var $4cb2b26710154c56$export$984c7bbbfc7ddffc;
var $4cb2b26710154c56$export$1ad8646bcba21c0e;
var $4cb2b26710154c56$export$4109102f950813a6;
var $4cb2b26710154c56$export$24c7f46a6e3605dd;
var $4cb2b26710154c56$export$2927016961429360;
$4cb2b26710154c56$export$f39a09f249340e2a = `hyn22G_focus-ring`;
$4cb2b26710154c56$export$8c4ee2c50c22c514 = `hyn22G_i18nFontFamily`;
$4cb2b26710154c56$export$75eb16cbfc18279c = `hyn22G_spectrum-FieldGroup`;
$4cb2b26710154c56$export$984c7bbbfc7ddffc = `hyn22G_spectrum-FieldGroup-group`;
$4cb2b26710154c56$export$1ad8646bcba21c0e = `hyn22G_spectrum-FieldGroup-group--horizontal`;
$4cb2b26710154c56$export$4109102f950813a6 = `hyn22G_spectrum-FocusRing-ring`;
$4cb2b26710154c56$export$24c7f46a6e3605dd = `hyn22G_spectrum-FocusRing ${$4cb2b26710154c56$export$4109102f950813a6}`;
$4cb2b26710154c56$export$2927016961429360 = `hyn22G_spectrum-FocusRing--quiet`;






function $ac9b96486fc4badf$var$RadioGroup(props, ref) {
    props = (0, $4hD9r$useProviderProps)(props);
    props = (0, $4hD9r$useFormProps)(props);
    let { isEmphasized: isEmphasized, children: children, orientation: orientation = "vertical" } = props;
    let domRef = (0, $4hD9r$useDOMRef)(ref);
    let state = (0, $4hD9r$useRadioGroupState)(props);
    let { radioGroupProps: radioGroupProps, labelProps: labelProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $4hD9r$useRadioGroup)(props, state);
    return /*#__PURE__*/ (0, $4hD9r$react).createElement((0, $4hD9r$Field), {
        ...props,
        ref: domRef,
        wrapperClassName: (0, $4hD9r$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($4cb2b26710154c56$exports))), "spectrum-FieldGroup"),
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        elementType: "span"
    }, /*#__PURE__*/ (0, $4hD9r$react).createElement("div", {
        ...radioGroupProps,
        className: (0, $4hD9r$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($4cb2b26710154c56$exports))), "spectrum-FieldGroup-group", {
            "spectrum-FieldGroup-group--horizontal": orientation === "horizontal"
        })
    }, /*#__PURE__*/ (0, $4hD9r$react).createElement((0, $f394bff9e10389a0$export$b118023277d4a5c3).Provider, {
        value: {
            isEmphasized: isEmphasized,
            state: state
        }
    }, children)));
}
/**
 * Radio groups allow users to select a single option from a list of mutually exclusive options.
 * All possible options are exposed up front for users to compare.
 */ const $ac9b96486fc4badf$export$a98f0dcb43a68a25 = /*#__PURE__*/ (0, $4hD9r$react).forwardRef($ac9b96486fc4badf$var$RadioGroup);




export {$337c5cb580c4e6ba$export$d7b12c4107be0d61 as Radio, $ac9b96486fc4badf$export$a98f0dcb43a68a25 as RadioGroup};
//# sourceMappingURL=module.js.map
